module.exports = __webpack_public_path__ + "img/pnskomputer.595a9f0b.svg";